import { request } from '@blade/common';
export const getAllTaskList = (data) => request({
    url: '/api/task-management/api/v1/task/list/all',
    method: 'POST',
    data,
});
/**
 *@Description: 请求列表
 */
export const getStatisticsList = (data) => request({
    url: '/api/task-management/api/v1/task/list',
    method: 'POST',
    data,
});
/**
 *@Description: 创建列表
 */
export const createTask = (data) => request({
    url: '/api/task-management/api/v1/task/createTask',
    method: 'POST',
    data,
});
/**
 *@Description: 更新列表
 */
export const updateTask = (data) => request({
    url: '/api/task-management/api/v1/task/updateTask',
    method: 'PUT',
    data,
});
/**
 *@Description: 任务详情
 */
export const taskDetail = (taskId) => request({
    url: `/api/task-management/api/v1/task/${taskId}`,
    method: 'GET',
});
/**
 *@Description: 聚档任务结果
 */
export const clusterTaskResult = (data) => request({
    url: `/api/entity-skill-management/api/v1/entity/document/search`,
    method: 'POST',
    data,
});
/**
 *@Description: 聚档任务结果详情
 */
export const clusterResultDetail = (data) => request({
    url: `/api/entity-skill-management/api/v1/entity/document/getDocumentDetail`,
    method: 'POST',
    data,
});
/**
 *@Description: 删除档案
 */
export const deleteFile = (data) => request({
    // url: `/api/task-management/api/v1/task/result/${taskId}/${detailId}`,
    url: `/api/entity-skill-management/api/v1/entity/document/delete`,
    method: 'post',
    data,
});
/**
 *@Description: 删除任务
 */
export const deleteTask = (taskId) => request({
    url: `/api/task-management/api/v1/task/${taskId}`,
    method: 'DELETE',
});
/**
 *@Description: 查询设备
 */
export const deviceList = () => request({
    url: `/api/map-management/api/v1/map/device/tree`,
    method: 'GET',
});
/**
 *@Description: 查询区域
 */
export const zoneList = (data) => request({
    url: `/api/map-management/api/v1/map/zone/tree`,
    method: 'POST',
    data,
});
/**
 *@Description: 查询地图信息
 */
const object = {};
export const mapQuery = (data) => request({
    url: `/api/map-management/api/v1/map/query/${data}`,
    method: 'POST',
    data: object,
});
/**
 *@Description: 人体边框
 */
export const lablePerson = (deviceId) => request({
    url: `/api/task-management/api/v1/task/device/lablePerson/deviceIds`,
    method: 'POST',
    data: [deviceId],
});
/**
 * 获取任务详情
 * @param portraitId portraitId
 * @returns
 */
export const getRuleData = (portraitId) => request({
    url: `/api/portrait-management/api/v1/alert/portrait/ruleData/${portraitId}`,
    method: 'GET',
});
export const getFeatureInfoByObjectId = (data) => request({
    url: `/api/timedb-management/api/v1/search/searchByObjectId`,
    method: 'POST',
    data,
});
/**
 * 获取身份库的人像库
 */
export const getLibAll = () => request({
    url: '/api/portrait-management/api/v1/portraitlib/list',
    method: 'POST',
    data: {},
});
